export const INVOICE_SEAT_COLUMNS = [
  { label: 'Reseller ID', columnName: 'resellerId', size: 'sm' },
  { label: 'Reseller Name', columnName: 'resellerName', size: 'sm' },
  { label: 'Year', columnName: 'year', size: 'sm' },
  { label: 'Month', columnName: 'month', size: 'sm' },
  { label: 'Created At', columnName: 'createdAt', size: 'sm' },
  { label: 'Last Updated At', columnName: 'updatedAt', size: 'sm' },
];

export const buttonStyle = {
  height: 36,
  backgroundColor: '#a5a5a5',
  textDecoration: 'none',
  color: 'black',
  '&:hover': {
    backgroundColor: '#a5a5a5',
  },
  textTransform: 'unset',
  fontSize: 14,
};
